import { useQuery } from '@tanstack/react-query';

import { getReportChatReasons } from './chat.api';

import { ApiFnReturnType } from '@/slw/shared/query-client';

export const useReportChatReasons = () => {
  return useQuery<ApiFnReturnType<typeof getReportChatReasons>>({
    queryKey: ['reportChatReasons'],
    queryFn: getReportChatReasons,
  });
};
